import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import * as Sentry from '@sentry/browser';
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import store from "./redux/store";
import { saveState } from "./utils/localStorage";

store.subscribe(() => {
  saveState({
    tableColumns: store.getState().users.columnsToDisplay,
  });
});

Sentry.init({ dsn: process.env.VUE_APP_SENTRY_DSN });

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
